import { useEffect } from 'react';
import type { ItineraryModel } from '@tajawal/web-flights-sdk/lib/types/itinerary.types';
import type FareFamiliesStore from '@tajawal/web-flights-sdk/lib/stores/fare-families.store';

export default function useFetchFareFamilies({
  store,
  itinerary,
  shouldFetch,
}: {
  store: FareFamiliesStore;
  itinerary: ItineraryModel;
  shouldFetch?: boolean;
}) {
  useEffect(() => {
    if (shouldFetch && itinerary) {
      store.fetch({ itinerary });
    }
  }, [itinerary, store, shouldFetch]);
}
